module.exports = __webpack_public_path__ + "img/navexam.b52166a8.jpg";